import { get } from "../../utils/axiosInstance";

export const fetchCurrentUser = () => {
  const url = `/rest/inventory/user/current_user/`;
  return get(url);
};
